:host {
  --font-family: var(--font-family-secondary);
  --text-color: var(--body-text-arrows-400);
  --background-color: var(--background-transparent);
  --active-background-color: var(--blue-layout-050-selected);
  --hover-background-color: var(--chart-051-hover);
  --item-padding: calc(var(--spacer) / 2) calc(2 * var(--spacer)) calc(var(--spacer) / 2) calc(3 * var(--spacer));
  position: relative;
  font-size: var(--body-size);
  padding: var(--item-padding);
  height: calc(4 * var(--spacer));
  cursor: pointer;
  background-color: var(--background-color);
  color: var(--text-color);
  width: 100%;
  display: flex;
  flex-direction: row;
  place-content: center space-between;
}

:host([noSpaceEscape]) {
  padding: 0 calc(2 * var(--spacer)) 0 0;

  .item-content {
    white-space: pre;
    line-height: 11px;
  }
}

:host([noSpaceEscape][isCompact]) {
  padding: 0;
  gz-form-field {
    width: 100%;
  }
  .item-content {
    // The negative value for margin is used because of the whitespace:pre;
    // which adds two tabs to the left and preserves white spaces.
    // em is used as a unit to preserve the two tabs on any font size
    margin-left: -2em;
    line-height: 11px;
  }
}

:host([isCompact]) {
  padding: calc(var(--spacer) / 2) 0 calc(var(--spacer) / 2) 0;
}

::slotted(*) {
  height: auto;
  margin-top: 2px;
}

.item-content {
  flex: 1;
  display: inline-block;
  width: 100%;
  height: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 24px;
}

:host(:hover),
:host(.menu-open) {
  background-color: var(--hover-background-color) !important;
  .inline-menu {
    opacity: 1;
  }
}

:host(:focus),
:host(:active),
:host([active]) {
  background-color: var(--active-background-color) !important;
  .inline-menu {
    opacity: 1;
  }
}

:host(:focus.menu-open:not([active])) {
  background-color: var(--chart-050-hover) !important;
}

:host([selectDisabled]) {
  .inline-menu {
    opacity: 0.3;
  }
}

:host([emptyState]) {
  color: var(--grey-layout-200-disabled);
  pointer-events: none;
  &:host(:hover) {
    background-color: transparent !important;
  }
}

:host([disabled]) {
  opacity: 0.3;
  &:host(:hover) {
    background-color: transparent !important;
  }
}

:host([editable]) {
  padding: 0 var(--spacer) 0 calc(var(--spacer) * 2);
}

:host([editable][isCompact]) {
  padding: 0 var(--spacer) 0 0;
}

.inline-menu {
  transition: all 0.2s ease;
  height: 100%;
  align-items: center;
  opacity: 0;
}

.editable-container {
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: space-between;
  width: 100%;

  gz-form-field {
    --margin-bottom-wrapper: 0;
    margin-right: var(--spacer);
  }

  gz-icon-button {
    display: flex;
  }

  .cancel-icon-button {
    margin-left: calc(var(--spacer) / 2);
  }
}
